import { 
  useGetOrgChartQuery, 
  useGetOrgChartContextQuery,
  useReassignEmployeeMutation 
} from '../store/apis/orgChart.api';
import { toast } from 'react-hot-toast';

export const useOrgChart = () => {
  const { 
    data: nodes = [], 
    isLoading: loading, 
    error: queryError, 
    refetch: refresh 
  } = useGetOrgChartQuery();

  const [reassignMutation, { isLoading: isReassigning }] = useReassignEmployeeMutation();

  const error = queryError 
    ? (queryError as any).data?.message || 'Failed to fetch org chart' 
    : null;

  const reassign = async (employeeId: string, newManagerId: string | null, type: 'reporting' | 'functional' = 'reporting') => {
    try {
      await reassignMutation({ employeeId, newManagerId, type }).unwrap();
    } catch (err: any) {
      toast.error(err.data?.message || err.message || 'Reassignment failed');
      throw err; // Re-throw to allow component to catch if needed
    }
  };

  return { nodes, loading, error, refresh, reassign, isReassigning };
};

export const useOrgChartContext = (userId: string) => {
  const { 
    data: nodes = [], 
    isLoading: loading, 
    error: queryError,
    refetch: refresh 
  } = useGetOrgChartContextQuery(userId, { skip: !userId });

  const error = queryError 
    ? (queryError as any).data?.message || 'Failed to fetch org chart context' 
    : null;

  return { nodes, loading, error, refresh };
};
